// @core/api/endpoints/team/list_team_avatars.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamAvatarsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List team avatars
 * Returns all uploaded avatars for a team. Includes the currently active avatar and historical uploads.
 */
export async function ListTeamAvatars(
  team_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamAvatarsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/avatars`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.get<ListTeamAvatarsResponse>(requestPath, { ...requestOptions, params });
}
